module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_bluepotion_m2.76e546b686ccbd2039ad3b9841886a40.png";